import { ActionContext, ActionTree } from 'vuex'
import moment from 'moment'

import { UpdateSpecialOfferReceiptDto } from '../../../api/@types'
import { SpecialOfferReceiptState, RootState } from '@/types/store'
import {
  getSpecialOfferReceipt,
  getSpecialOfferReceipts,
  updateSpecialOfferReceipt,
} from '@/api/special-offer-receipt'
import { UserRole } from '../../types/user'
import { SpecialOfferReceiptType } from '../../types/special-offer'

type Context = ActionContext<SpecialOfferReceiptState, RootState>

export interface SpecialOfferReceiptActions
  extends ActionTree<SpecialOfferReceiptState, RootState> {
  updateSpecialOfferReceipt: (
    ctx: Context,
    {
      id,
      dto,
      userRole,
      userId,
    }: {
      id: number
      dto: UpdateSpecialOfferReceiptDto
      userRole: UserRole
      userId: number
    },
  ) => Promise<void>
}

export const actions: SpecialOfferReceiptActions = {
  async getSpecialOfferReceipts({ commit }, { query, target }): Promise<void> {
    commit('setIsSpecialOfferReceiptLoading', true)
    const params = {
      target,
      ...query,
    }
    const specialOffers = await getSpecialOfferReceipts(params)
    commit('specialOfferReceiptLoaded', specialOffers)
    commit('setIsSpecialOfferReceiptLoading', false)
  },
  async getSpecialOfferReceipt({ commit }, id: number): Promise<void> {
    commit('setIsSpecialOfferReceiptLoading', true)
    const specialOffer = await getSpecialOfferReceipt(id)
    commit('setSpecialOfferReceipt', specialOffer)
    commit('setIsSpecialOfferReceiptLoading', false)
  },
  async updateSpecialOfferReceipt(
    { commit, dispatch },
    {
      id,
      dto,
      userRole,
      userId,
    }: {
      id: number
      dto: UpdateSpecialOfferReceiptDto
      userRole: UserRole
      userId: number
    },
  ): Promise<void> {
    commit('setIsSpecialOfferReceiptLoading', true)
    const checkedAt = moment().toISOString()
    if (dto.ngReason === null) {
      if (userRole === UserRole.LINKER) {
        dto.linkerOkedAt = checkedAt
        dto.okedByLinkerId = userId
      }
      if (userRole === UserRole.LEADER || userRole === UserRole.ADMIN) {
        dto.leaderOkedAt = checkedAt
        dto.okedByLeaderId = userId
      }
    } else {
      if (userRole === UserRole.LINKER) {
        dto.linkerNgedAt = checkedAt
        dto.ngedByLinkerId = userId
      }
      if (userRole === UserRole.LEADER || userRole === UserRole.ADMIN) {
        dto.leaderNgedAt = checkedAt
        dto.ngedByLeaderId = userId
      }
    }
    await updateSpecialOfferReceipt(id, dto)
    await dispatch('getSpecialOfferReceipt', id)
    commit('setIsSpecialOfferReceiptLoading', false)
  },
  setReceiptType({ commit }, receiptType: SpecialOfferReceiptType): void {
    commit('setReceiptType', receiptType)
  },
}
